"use client";

import { usePlayer } from "@/context/player-context";
import { Content } from "@/services/content/types";
import { createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Icon from "./icon";

type PodcastPlayButtonType = {
  podcast: Content.PodcastEpisode;
  small?: boolean;
};

const getArtworkUrl = (podcast: Content.PodcastEpisode) => {
  const src =
    podcast.fields["podcast-show"]?.fields.image?.fields.file?.url ||
    podcast.fields.image?.fields.file?.url;

  if (!src) return undefined;

  const url = new URL(
    createImageUrl(src, { crop: "1:1", width: 600 }),
    window.location.origin,
  );
  url.searchParams.set("fm", "png");
  return url.href;
};

const playInApp = (podcast: Content.PodcastEpisode) => {
  window.postMessage(
    {
      type: "play-podcast",
      url: podcast.fields.media?.mediaUrl,
      title: podcast.fields.title,
      show: podcast.fields["podcast-show"]?.fields.title,
      imageUrl: getArtworkUrl(podcast),
      articleUrl: new URL(`/podd/${podcast.fields.slug}`, window.location.origin)
        .href,
    },
    window.location.origin,
  );
};

const PodcastPlayButton = ({ podcast, small }: PodcastPlayButtonType) => {
  const { podcast: playingPodcast, openPodcast, closePodcast } = usePlayer();

  const isActive = playingPodcast && playingPodcast?.sys.id == podcast?.sys?.id;
  return (
    <>
      <button
        className={classNames(
          "ignore-group-hover flex items-center mt-2 hover:underline",
          small ? "text-md" : "text-lg"
        )}
        onClick={(e) => {
          e.preventDefault();
          if (window.efnNativeAudio && podcast.fields.media?.mediaUrl) {
            playInApp(podcast);
            return;
          }
          isActive ? closePodcast() : openPodcast(podcast);
        }}
      >
        {isActive ? (
          <Icon.PauseInverted
            bgClassName="fill-red-700"
            className={classNames(
              "fill-white-500",
              small ? "w-4 h-4 mr-1" : " w-7 h-7 mr-2"
            )}
          />
        ) : (
          <Icon.PlayInverted
            bgClassName="fill-red-700"
            className={classNames(
              "fill-white-500",
              small ? "w-4 h-4 mr-1" : " w-7 h-7 mr-2"
            )}
          />
        )}
        {isActive ? (
          <span className="font-bold ">Lyssnar...</span>
        ) : (
          <span className="font-bold ">Lyssna</span>
        )}
      </button>
    </>
  );
};

export default PodcastPlayButton;
